import React, { useEffect, useRef } from 'react';

import { MfeNames, SingleSpaService } from 'services/singleSpa';

interface SingleSpaMfeProps {
  name: MfeNames;
}

const SingleSpaMfe = (props: SingleSpaMfeProps) => {
  const { name } = props;
  const rootElement = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!name) {
      return;
    }

    const singleSpaService = new SingleSpaService(name, rootElement.current);

    void singleSpaService.mount();

    return () => {
      singleSpaService.unmount();
    };
  }, [name]);

  return <div id={`mfe:${name}`} ref={rootElement} />;
};

export default SingleSpaMfe;
